export default function ProblemSection() {
  const cards = [
    {
      icon: "ri-time-line",
      title: "The Government Timeline",
      description: "Routine processing: 4–6 weeks. Government expedited service: 2–3 weeks. Neither includes mailing time, which can add another 2 weeks. If your trip is in less than 6 weeks, the standard government route simply won't get you there in time.",
      accent: "bg-amber-50 border-amber-200",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Agency Appointments Are Gone",
      description: "Regional passport agencies require appointments. In 2026, with over 27 million passports issued, appointments book up 2–4 weeks in advance. You cannot walk in. You cannot call and get seen tomorrow. The appointment system is the bottleneck.",
      accent: "bg-red-50 border-red-200",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
    },
    {
      icon: "ri-user-shared-line",
      title: "Most Couriers Are Middlemen",
      description: "FedEx Office, Staples, and most online passport services are resellers — they charge you a markup and hand your application to an actual registered courier. You pay twice. Fast Passport Center IS the registered courier. No middleman. No markup.",
      accent: "bg-teal-50 border-teal-200",
      iconBg: "bg-teal-100",
      iconColor: "text-teal-700",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">The Reality</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Why Standard Passport Processing{" "}
            <span className="text-[#F6C344]">Isn't Fast Enough</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Understanding the bottlenecks in the passport system helps you see why a registered courier makes all the difference.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`${card.accent} rounded-xl p-6 md:p-7 border transition-shadow hover:shadow-md`}
            >
              <div className={`${card.iconBg} w-12 h-12 flex items-center justify-center rounded-lg mb-5`}>
                <i className={`${card.icon} ${card.iconColor} text-xl`}></i>
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-[#1A365D] mb-3">{card.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}